import { ServiceHandler } from '../utils';

const postLoginCredentialsHandler = ServiceHandler({
  url: '/api/auth/v1/login',
  method: 'post',
});
/**
 * @deprecated
 */
export const postLoginCredentials = (credentials: any) => {
  return postLoginCredentialsHandler({
    data: {
      username: credentials.email,
      password: credentials.password,
    },
  });
};

const postLoginCredentialsWithMfaHandler = ServiceHandler({
  url: '/api/auth/v1/login',
  method: 'post',
});
/**
 * @deprecated
 */
export const postLoginCredentialsWithMfa = (credentials: any) => {
  return postLoginCredentialsWithMfaHandler({
    data: {
      username: credentials.email,
      password: credentials.password,
      mfaType: credentials.mfaType,
      mfaCode: credentials.mfaCode,
    },
  });
};

const validatePasswordHandler = ServiceHandler({
  url: '/api/auth/v1/validate-password',
  method: 'post',
});
export const validatePassword = (params: any, payload: any) => {
  return validatePasswordHandler({ params, data: payload });
};

const submitSignupNewAccountHandler = ServiceHandler({
  url: 'api/auth/v1/signup',
  method: 'post',
});
export const submitSignupNewAccount = (credentials: any, token: any) => {
  return submitSignupNewAccountHandler({
    params: { validationToken: token },
    data: JSON.stringify(credentials),
  });
};

const checkPasswordResetValTokenHandler = ServiceHandler({
  url: '/api/auth/v1/checkPasswordReset/:token',
});
export const checkPasswordResetValToken = (token: any) => {
  return checkPasswordResetValTokenHandler(token);
};

const postPasswordResetValTokenHandler = ServiceHandler({
  url: '/api/auth/v1/validatePasswordReset/:valToken',
  method: 'post',
});
export function postPasswordResetValToken(valToken: any, passwords: any) {
  return postPasswordResetValTokenHandler(valToken, { data: passwords });
}

const submitSignupEmailHandler = ServiceHandler({
  url: 'api/auth/v1/email',
  method: 'post',
});
export const submitSignupEmail = (payload: any, captcha: any) => {
  return submitSignupEmailHandler({
    params: { 'g-recaptcha-response': captcha },
    data: payload,
  });
};

const checkSignupEmailTokenHandler = ServiceHandler({
  url: 'api/auth/v1/validationTokens/:token',
});
export const checkSignupEmailToken = (token: any) => {
  return checkSignupEmailTokenHandler(token);
};

const joinExistingAccountHandler = ServiceHandler({
  url: 'api/auth/v1/join',
  method: 'post',
});
export const joinExistingAccount = (payload: any, token: any) => {
  return joinExistingAccountHandler({
    params: { validationToken: token },
    data: JSON.stringify(payload),
  });
};

const submitNewAccountValTokenHandler = ServiceHandler({
  url: 'api/auth/v1/signup',
  method: 'post',
});
export const submitNewAccountValToken = (credentials: any, token: any) => {
  return submitNewAccountValTokenHandler({
    params: { validationToken: token },
    data: JSON.stringify(credentials),
  }).catch(() => {
    // console.log('error: ', error.response);
  });
};

const checkUserInvitedValTokenHandler = ServiceHandler({
  url: '/api/auth/v1/checkUserInvited/:token',
});
export const checkUserInvitedValToken = (token: any) => {
  return checkUserInvitedValTokenHandler(token);
};

const postUserInvitedValTokenHandler = ServiceHandler({
  url: '/api/auth/v1/validateUserInvited/:token',
  method: 'post',
});
export function postUserInvitedValToken(token: any, passwords: any) {
  return postUserInvitedValTokenHandler(token, { data: passwords });
}

const resendValEmailHandler = ServiceHandler({
  url: 'api/auth/v1/resendValidationEmail/:email',
  method: 'post',
});
export function resendValEmail(email: any) {
  return resendValEmailHandler(email);
}

const requestPasswordResetHandler = ServiceHandler({
  url: 'api/auth/v1/passwords/:email/reset',
  method: 'post',
});
export function requestPasswordReset(email: any, captcha: any) {
  return requestPasswordResetHandler(email, {
    params: { 'g-recaptcha-response': captcha },
  });
}
